import { CircularLoader } from '#/components/Loader/Circular'

export function FormbuilderCircularLoader() {
  return <CircularLoader minHeight={150} />
}
